import React from "react";
import img from "../../../../assets/img/Home/cover-img (2).png";
import profile from "../../../../assets/img/Home/profile.png";
import like from "../../../../assets/img/icons/like.svg";

const CommentBox = ({info}) => {
  return (
    <div className="user-CommentBox">
      <img className="user-CommentBox-thumbnail" src={img} /> 
      {/* media check shavad */}
      <div className="user-CommentBox--proflebox">
        <img src={info.author.avatar} className="user-CommentBox--proflebox--img" />
        <div className="user-CommentBox--proflebox-name">
          {info.author.full_name}
          <span>دیدگاه ثبت کرد</span>
        </div>
      </div>
      <p className="user-CommentBox--body">
        {info.body}
      </p>
      <div>
        <div className="flex justify-between items-center">
            <div className="flex items-center">
                <div className="user-CommentBox--status text-[#009E35] bg-[#C7EBD3]">
               {info.status}
                </div>
                <p className="font-[500] text-[14px] text-[#B5B9BE] mr-[6px] mb-[-4px]">{info.created_at}</p>
            </div>
          <div className="flex items-center">
            <button className="gray-button">پاسخ</button>
            <div className="flex items-center CommentBox__header--like">
              <img src={like} />
              <p className="font-[500] text-[14px] text-[#B5B9BE] mr-[6px] mb-[-4px]">
                {info.like_count}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommentBox;
